import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Style from './Note.module.css'

// Default variant: Red
const variantClasses = {
  pink: Style.pink,
  orange: Style.orange,
  yellow: Style.yellow,
  green: Style.green,
  blue: Style.blue,
  purple: Style.purple,
  brown: Style.brown,
  gray: Style.gray,
  conflict: Style.conflict,
}

const Note = ({ variant, children, className, status, isDayOff, ...props }) => (
  <div
    className={classnames(
      Style.note,
      Style[status],
      isDayOff ? variantClasses.gray : variantClasses[variant],
      isDayOff ? Style.dayOff : undefined,
      className,
    )}
    {...props}
  >
    {children}
  </div>
)

Note.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  isDayOff: PropTypes.bool,
  status: PropTypes.string,
  className: PropTypes.string,
}

export default Note
